import { useMutation } from '@tanstack/react-query';
import axios, { AxiosResponse } from 'axios';
import { environment } from '../config/environment';

const createWallet = async (
  templateId: string,
  data: Record<string, string | boolean | number | string[]>
): Promise<AxiosResponse> => {
  const response = await axios.post(
    `${environment.API}/wallets/templates/${templateId}`,
    {
      metadata: data,
    },
    {
      headers: {
        'Content-Type': 'application/json; charset=utf-8'
      }
    }
  );
  return response.data;
};

export const useCreateWallet = (templateId: string) => {
  return useMutation({
    mutationFn: (data: Record<string, string | boolean | number | string[]>) => createWallet(templateId, data),
  });
}; 